import { styled } from 'libs/ui/styled';

export const CurrencyContainer = styled('div')({
  width: 100,
  '& .priceField-Currency .MuiAutocomplete-inputRoot': {
    paddingRight: '20px!important',
  },
});
